import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import YouTube from "react-youtube";
import createAnimationSelectedAnimationTypeSelector from "selectors/createAnimationSelectedAnimationType";
import AnimationSection from "./AnimationSection";

const UseAnimationSection: React.FC = () => {
    const animationType = useSelector(
        createAnimationSelectedAnimationTypeSelector
    );

    const animationTypeRigName = React.useMemo(() => {
        if (animationType === "LEFT_HAND") {
            return "Left Hand";
        } else if (animationType === "RIGHT_HAND") {
            return "Right Hand";
        } else {
            throw new Error("Unknown animation rig");
        }
    }, [animationType]);

    return (
        <AnimationSection
            description="In this section, we will be going over the steps required to use this animation in Blender"
            title="Use Animation"
        >
            <h3>Step 1: Install Blender Addon</h3>
            <p>
                To use your animation, you need to install the Rend A Hand
                blender addon if you have not done so already. You can learn how
                to do so by clicking the link below.
            </p>
            <Link to="/addon">Download Addon</Link>
            <h3>Step 2: Add Armature</h3>
            <p>
                The first thing that we need to do is add a rig corresponding to
                the animation type. In Object Mode, go to the <code>Add</code>{" "}
                menu. Then, at the bottom you will see an option called{" "}
                <code>Rend A Hand Rigs</code>. From there, select{" "}
                <code>{animationTypeRigName}</code>.
            </p>
            <h3>Step 3: Perform the Animation</h3>
            <p>
                Next, you can create your animation. To do that, select the
                newly created Armature. Then, go to the{" "}
                <code>Object Properties</code>. From there, go to the{" "}
                <code>Rend A Hand</code> options. Select your file and then
                press the button. That will create the animation.
            </p>
            <hr />
            <h3>Having Trouble? Watch our Example Video</h3>
            <p>
                This video goes through all of the steps to create a Rend A Hand
                animation.
            </p>
            <YouTube videoId={"mr37k2-4zuk"} />
        </AnimationSection>
    );
};

export default UseAnimationSection;
